import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

import { getPrimaryLanguage } from "@krea/customer-features/utils";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        partnerWeb: require("./translations/partner/en.json"),
        common: require("@krea/customer-features/translations/common/en.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/en.json"),
      },
      sv: {
        partnerWeb: require("./translations/partner/sv.json"),
        common: require("@krea/customer-features/translations/common/sv.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/sv.json"),
      },
      fi: {
        partnerWeb: require("./translations/partner/fi.json"),
        common: require("@krea/customer-features/translations/common/fi.json"),
        partnerApplication: require("@krea/customer-features/shared-components/partner-application-form/translations/fi.json"),
      },
    },
    lng: getPrimaryLanguage(),
    fallbackLng: "en",
    supportedLngs: ["sv", "en", "fi"],
    ns: ["partnerWeb", "partnerApplication", "common"],
    defaultNS: ["partnerWeb", "partnerApplication"],
    fallbackNS: ["partnerApplication", "common"],
    interpolation: {
      escapeValue: false,
    },
    react: {
      transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p", "ul", "li"],
    },
  });

// eslint-disable-next-line import/no-default-export
export default i18n;
